import React, { Component } from 'react';
import * as d3 from 'd3';
import './TreeD3.css';
import { restructureResponse } from '../../helpers/sparql';
// import data from './data.json';

let relationDef = {
  bestuurder: { color: 'green' },
  aandeelhouder: { color: '#007bff' },
  aansprakelijkheid: { color: '#e67900' }
};

let mapIconToRelation = {
  icon2: 'bestuurder', // hand-point-left
  icon: 'aandeelhouder', // percent
  icon3: 'aansprakelijkheid' // gavel
};

class TreeD3 extends Component {
  constructor(props) {
    super(props);
    this.svgEl = React.createRef();
  }

  componentDidMount() {
    this.drawTree(this.props);
  }

  componentDidUpdate() {
    this.drawTree(this.props);
  }

  addDepth(data, depth, amountPerDepth) {
    data.depth = depth;
    if (!amountPerDepth['depth' + depth]) {
      amountPerDepth['depth' + depth] = 1;
    } else {
      amountPerDepth['depth' + depth] = amountPerDepth['depth' + depth] + 1;
    }
    if (data.children) data.children.forEach(child => this.addDepth(child, depth + 1, amountPerDepth));
    return { data, amountPerDepth };
  }

  defineHeight(amountPerDepth) {
    let max = Object.keys(amountPerDepth).reduce((org, key) => {
      let amount = amountPerDepth[key];
      return amount > org ? amount : org;
    }, 0);
    return max * 20;
  }

  drawTree(props) {
    if (!props.data) return;
    let mode = props.treeType || 'horizontal';
    let selectedURI = props.pubsub[this.props.subscribeVariableForTreeItemSelection];
    let selectedRelation = props.pubsub[this.props.subscribeVariableForTreeConnectionHighlight];
    let filterValue = props.pubsub[this.props.subscribeVariableForFilter];
    // if (selectedRelation === 'all') selectedRelation = null;

    let items = restructureResponse(props.data);

    let headVars = props.data.head.vars;
    let treeItemLabelKey = headVars[0];
    let treeItemURIKey = headVars[1];
    let parentItemURIKey = headVars[2];

    let sortingReady = false;
    let sortLoop = function() {
      sortingReady = true;
      for (let j = 0; j < items.length; j++) {
        let parentIndex = items.findIndex(it => it[treeItemURIKey] === items[j][parentItemURIKey]);
        if (parentIndex === -1) continue;
        if (j < parentIndex) {
          let tmp = items[j];
          items[j] = items[parentIndex];
          items[parentIndex] = tmp;
          sortingReady = false;
        }
      }
    };

    if (!sortingReady) {
      sortLoop();
    }

    let labelLength = mode === 'horizontal' ? 34 : 20;

    for (let i = items.length - 1; i >= 0; i--) {
      let item = items[i];
      if (item[treeItemLabelKey].length > labelLength) {
        item[treeItemLabelKey] = item[treeItemLabelKey].slice(0, labelLength) + '...';
      }

      if (item[treeItemURIKey] === selectedURI) {
        item.containsSelection = true;
      }
      item.relations = Object.keys(mapIconToRelation).reduce((org, icon) => {
        return {
          ...org,
          [mapIconToRelation[icon]]: !!item[icon]
        };
      }, {});

      if (selectedRelation) {
        if (item.relations[selectedRelation]) {
          item.highlight = relationDef[selectedRelation].color;
        } else if (selectedRelation === 'all') {
          item.highlight = 'black';
        } else {
          item.highlight = '#c3c3c3';
        }
      }

      if (item.datumOprichting > filterValue) {
        item.highlight = 'lightgrey';
      }

      let parent = items.find(it => {
        return it[treeItemURIKey] === item[parentItemURIKey];
      });
      if (parent) {
        parent.children = parent.children || [];
        parent.children.push(item);

        // if (item.containsSelection) {
        //   parent.containsSelection = true;
        // }
        // if (item.highlight) {
        //   parent.parentHighlight = relationDef[selectedRelation].color;
        // }
        items.splice(i, 1);
      }
    }

    let data = items[0];

    if (props.rootLabel) {
      data = {
        [treeItemLabelKey]: props.rootLabel,
        [parentItemURIKey]:
          'http://www.kvk.nl/handelsregister/gegevenswoordenboek/hr/concernrelaties/heineken/v1#Rechtspersoon1',
        [treeItemURIKey]:
          'http://www.kvk.nl/handelsregister/gegevenswoordenboek/hr/concernrelaties/heineken/v1#Rechtspersoon9',
        children: [...items, ...items]
      };
    }

    let res = this.addDepth(data, 0, {});
    let amountPerDepth = res.amountPerDepth;
    data = res.data;

    let height = this.defineHeight(amountPerDepth);

    let width = 750;
    let radius = width / 2;
    let svg = d3.select(this.svgEl.current);

    svg
      .style('width', '100%')
      .style('height', 'auto')
      .style('padding', '10px')
      .style('box-sizing', 'border-box')
      .style('font', '10px sans-serif');

    svg.selectAll('*').remove();
    let tree;
    if (mode === 'horizontal') {
      tree = d3.tree().size([height, 600]);
    } else {
      tree = d3.cluster().size([2 * Math.PI, radius - 100]);
    }

    // const root = tree(d3.hierarchy(data).sort((a, b) => a.height - b.height || a.data[treeItemLabelKey].localeCompare(b.data[treeItemLabelKey])));
    const root = tree(d3.hierarchy(data));

    const g = svg.append('g');

    const linkHorizontal = d3
      .linkHorizontal()
      .x(function(d) {
        return d.y;
      })
      .y(function(d) {
        return d.x;
      });

    const linkRadial = d3
      .linkRadial()
      .angle(d => d.x)
      .radius(d => d.y);

    let linkFunc;

    if (mode === 'horizontal') {
      linkFunc = linkHorizontal;
    } else {
      linkFunc = linkRadial;
    }

    const link = g
      .append('g')
      .attr('fill', 'none')
      .attr('stroke', '#555')
      .attr('stroke-opacity', 0.4)
      .attr('stroke-width', 0.5)
      .selectAll('path')
      .data(root.links())
      .enter()
      .append('path')
      .attr('opacity', d => {
        if (d.target.data.highlight === 'black') {
          return d.target.data.containsSelection ? 1 : 0.3;
        } else {
          return 1;
        }
      })
      .attr('stroke', d => d.target.data.highlight)
      .attr('stroke-width', d => {
        if (d.target.data.containsSelection && d.target.data.highlight !== 'black') {
          return d.target.data.highlight ? 2 : 1;
        } else {
          return d.target.data.highlight ? 1 : 0.5;
        }
      })
      .attr('d', linkFunc);
    // .attr('d', d => {
    //   console.log(d)
    //   return linkFunc({
    //     source: [d.source.y, d.source.x],
    //     target: [d.target.y, d.target.x]
    //   });
    // });

    let transformFunc;
    if (mode === 'horizontal') {
      transformFunc = d => `translate(${d.y},${d.x})`;
    } else {
      transformFunc = d => `
              rotate(${(d.x * 180) / Math.PI - 90})
              translate(${d.y},0)
              `;
    }

    const node = g
      .append('g')
      .attr('stroke-linejoin', 'round')
      .attr('stroke-width', 3)
      // .attr('fill', 'black')
      .selectAll('g')
      // .data(root.descendants().reverse())
      .data(root.descendants())
      .enter()
      .append('g')
      .attr('fill', d => d.data.highlight || 'black')
      .attr('font-weight', d => (d.data.containsSelection ? 'bold' : 'normal'))
      .attr('cursor', 'pointer')
      .attr('transform', transformFunc)
      .on('click', d => {
        if (props.publishVariable) {
          props.publish(props.publishVariable, d.data[treeItemURIKey]);
        }
      })
      .on('mouseover', function(d) {
        d3.select(this)
          .selectAll('text')
          .attr('font-weight', 'bold');
        // .attr('fill', '#4c8bf1');
      })
      .on('mouseout', function(d) {
        d3.select(this)
          .selectAll('text')
          .attr('font-weight', d => (d.data.containsSelection ? 'bold' : 'normal'));
        // .attr('fill', '#000');
      });

    if (mode === 'horizontal') {
      node
        .append('text')
        .attr('dy', '0.31em')
        // .style('font-size', '8px')
        // .attr('x', d => (d.x < Math.PI === !d.children ? 6 : -6))
        // .attr('text-anchor', d => (d.x < Math.PI === !d.children ? 'start' : 'end'))
        // .attr('transform', d => (d.x >= Math.PI ? 'rotate(180)' : null))
        .text(d => d.data[treeItemLabelKey])
        .filter(d => d.children)
        .clone(true)
        .lower()
        .attr('stroke', 'white');
    } else {
      node
        .append('text')
        .attr('dy', '0.31em')
        // .style('font-size', '12px')
        // .attr('x', d => (d.x < Math.PI === !d.children ? 6 : -6))
        .attr('x', d => (!d.children ? (d.x < Math.PI ? 6 : -6) : d.x < Math.PI ? -28 : 28))
        // .attr('text-anchor', d => (d.x < Math.PI === !d.children ? 'start' : 'end'))
        .attr('text-anchor', d => (d.x < Math.PI ? 'start' : 'end'))
        .attr('transform', d => (d.x >= Math.PI ? 'rotate(180)' : null))
        .text(d => d.data[treeItemLabelKey])
        .filter(d => d.children)
        .clone(true)
        .lower()
        .attr('stroke', 'white');
    }

    try {
      // document.body.appendChild(svg.node());
      const box = g.node().getBBox();
      // document.body.removeChild(svg);
      // svg.attr('viewBox', `-350 -350 700 700`);
      // svg.attr("viewBox", `${box.x} ${box.y} ${box.width} ${box.height}`);

      svg
        .attr('width', box.width)
        .attr('height', box.height)
        .attr('viewBox', `${box.x} ${box.y} ${box.width} ${box.height}`);
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    return (
      <div style={{ padding: '12px' }}>
        <svg ref={this.svgEl} />
      </div>
    );
  }
}

export default TreeD3;
